module.exports = __webpack_public_path__ + "img/boy_010014.202da358.png";